// Shared reviews store — single source of truth for ratings everywhere

export function getAllReviews() {
  try {
    const stored = localStorage.getItem('LathiNyx_reviews');
    return stored ? JSON.parse(stored) : [];
  } catch { return []; }
}

export function addReview(review) {
  const existing = getAllReviews();
  const updated = [review, ...existing];
  localStorage.setItem('LathiNyx_reviews', JSON.stringify(updated));
  return updated;
}

export function getAvgRating(reviews) {
  if (!reviews.length) return '5.0';
  return (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);
}
